import 'app/page/help.scss';

import shared, { config } from 'shared/shared';
import Tools from 'shared/tools';
import FeedbackModal from 'shared/widget/feedback-modal';

(function () {

    const vm = {
        config,
        feedbackModal: ko.observable(new FeedbackModal)
    };

	const level = $('#help-content').data("level");
	
    const init = function() {
    	shared.initShared();

    	setHelpTocHeight();    	
    	$(window).resize(function() {
    		setHelpTocHeight();
    	});

    	var contact = $('#help-content').data("showContact");
    	if (contact) {
			$('.help-content').append($('#cntct-contact-info').html());
			$('.help-content').children('div').show();
			$('.help-content').find('.hide-display').show().css('visibility', 'visible');
    		
    	}else{
	    	//display the first topic on load
			$('.help-content').append($('#sf-tools').html());
			$('.help-content').children('div').show();
			$('.help-content').find('.hide-display').show().css('visibility', 'visible');
    	}
    	
		Tools.init();

		$('body').on('click', '.link', function (event) {
			event.preventDefault();
			$( 'html, body' ).animate( { scrollTop: $('.help-content').offset().top - 50 }, 'slow', function () {
			});

			var target = $(event.target);
			var content = $('#'+ target.data('target')).html();
			$('.help-content').empty().append(content);
			$('.help-content').children('div').show('slow');
			$('.help-content').find('.hide-display').show('slow').css('visibility', 'visible');
			window.location.hash = '#'+ target.data('target');
		});

    	$('.sublink').click(function(event){
    		event.preventDefault();
			$( 'html, body' ).animate( { scrollTop: $('.help-content').offset().top - 50 }, 'slow', function () {
			});
    		var target = $(event.target);    		
    		var content = $('#'+ target.data('parent')).html();
    		$('.help-content').empty().append(content);
    		$('.help-content').children('div').show('slow').css('visibility', 'visible');
    		$('.help-content').find('#'+ target.data('target')).show('slow').css('visibility', 'visible');
			window.location.hash = '#'+ target.data('target');
    	});

        if(window.location.hash) {
            $('.link, .sublink').each(function(){
                if($(this).data('target') == window.location.hash.slice(1)) {
                    $(this).click();
                }
            });
        }

		ko.applyBindings(vm, document.getElementById('ko-main-page'));
    };

    var setHelpTocHeight = function(){
    	var windowWidth = $(window).width();
    	if(windowWidth > 750){
        	var toc_height = $('#help-toc .help-site-features .help-box-content').height();
        	$('#help-toc .help-contact .help-box-content').height(toc_height);
        	$('#help-toc .help-accessibility .help-box-content').height(toc_height);    		
    	}else{
        	$('#help-toc .help-contact .help-box-content').css('height', 'auto');
        	$('#help-toc .help-accessibility .help-box-content').css('height', 'auto');
    	}
    };

    init();
}());



// WEBPACK FOOTER //
// ./javascript/app/page/help/help.js